import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UIRouter }         from '@uirouter/angularjs';

import { CompanyIntegrationsModel } from '../companies/models/company.integrations';
import { MessagesService }          from '../messages/messages.service';
import { SessionService }           from '../sessions/session.service';
import { WsApiService }             from './ws-api.service';
import { WsApiSettingsModel }       from './models/ws-api.settings.model';

@Component({
  selector   : 'ws-api-settings',
  template: require('./ws-api.settings.component.html')
})
export class WsApiSettingsComponent {
  @Input() settings     : CompanyIntegrationsModel;
  @Input() wsApiSettings: WsApiSettingsModel;

  title : string = this.wsApiService.title;

  constructor (
    private messagesService : MessagesService,
    private router          : UIRouter,
    public  sessionService  : SessionService,
    private translateService: TranslateService,
    private wsApiService    : WsApiService
  ) {}

  activate () : void {
    this.wsApiService.activate()
    .then(() => {
      this.messagesService.show(this.translateService.instant('JS_SPACE.INTEGRATIONS.ACTIVATED', {
        name: this.title
      }), 'success');

      this.router.stateService.reload();
    })
    .catch(err => {
      this.messagesService.error(err);
    });
  }

  deactivate () : void {
    this.wsApiService.deactivate()
    .then(() => {
      this.messagesService.show(this.translateService.instant('JS_SPACE.MESSAGES.REMOVED_INTEGRATION', {
        name: this.title
      }), 'success');

      this.router.stateService.reload();
    })
    .catch(err => {
      this.messagesService.error(err);
    });
  }

  generateApiKey () : void {
    this.wsApiService.generateApiKey()
    .then(() => {
      this.messagesService.show(this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.WS_API.NEW_API_KEY_GENERATED'), 'success');

      this.router.stateService.reload();
    })
    .catch(err => {
      this.messagesService.error(err);
    });
  }
}
